const form = document.querySelector("#configurator");
const parts = ["petals", "center", "stems", "bow"];
// No tema Shopify, o snippet Liquid publica window.FLOWERSPOP_SHOPIFY com as variantes reais
// (id, preço, disponibilidade) e a raiz das rotas; fora dele, vale PRODUCT_CONFIG (protótipo local).
const shopify = window.FLOWERSPOP_SHOPIFY || null;
const metallicUpgrade = PRODUCT_CONFIG.metallicUpgrade;
const sizeInfo = (size) => ({ ...PRODUCT_CONFIG.sizes[size], available: true, ...shopify?.variants?.[size] });

// Cor da paleta a partir do input (nome em data-name do swatch, HEX na variável --swatch).
const colorFromInput = (input) => {
  const label = input.closest("label");
  return { value: input.value, label: label.dataset.name, hex: label.style.getPropertyValue("--swatch").trim() };
};
// Código do catálogo físico (vazio quando ainda não cadastrado, como nos metálicos).
const colorCode = (value) => PRODUCT_CONFIG.colorCodes[value] || "";
const getColorInput = (value) => form.querySelector(`input[name="color"][value="${value}"]`);

// Catálogo de cores do admin da Shopify (Content > Metaobjects > "FlowersPop balloon colors"; handle
// = valor da paleta), publicado pelo snippet em FLOWERSPOP_SHOPIFY.colors como
// { "glossy-red": { name, code, available } }. Nome e código do admin valem sobre os do código;
// cor com Available desligado some da paleta (e a linha inteira, se nenhuma sobrar). Cor que não
// está no catálogo fica como no código.
function applyColorCatalog(colors) {
  if (!colors) return;
  for (const input of form.querySelectorAll('input[name="color"]')) {
    const entry = colors[input.value];
    if (!entry) continue;
    const label = input.closest(".swatch");
    if (entry.name && entry.name !== label.dataset.name) {
      input.setAttribute("aria-label", input.getAttribute("aria-label").replace(label.dataset.name, entry.name));
      label.dataset.name = entry.name;
    }
    PRODUCT_CONFIG.colorCodes[input.value] = entry.code || "";
    const available = entry.available !== false;
    input.disabled = !available;
    label.hidden = !available;
  }
  for (const grid of form.querySelectorAll(".swatch-grid")) {
    const empty = !grid.querySelector(".swatch:not([hidden])");
    grid.hidden = empty;
    grid.previousElementSibling.hidden = empty; // título "Glossy" ou "Metallic + $3.50"
  }
}
applyColorCatalog(shopify?.colors);

// Esferas do swatch studio (tools/swatch-studio) no lugar do disco em CSS: na Shopify, o Thumbnail
// do catálogo (CDN, trocável no admin); no protótipo local, assets/swatches/<valor>.webp. Cor sem
// imagem continua com o disco em CSS.
const swatchImage = (value, colors = shopify?.colors) =>
  (colors ? colors[value]?.thumb : `/assets/swatches/${value}.webp`) || null;
function applySwatchImages(colors) {
  for (const input of form.querySelectorAll('input[name="color"]')) {
    const url = swatchImage(input.value, colors);
    if (!url) continue;
    const label = input.closest(".swatch");
    label.style.setProperty("--swatch-image", `url("${url}")`);
    label.classList.add("has-image");
  }
}
applySwatchImages(shopify?.colors);

// Cor padrão de cada parte; se ela estiver indisponível no catálogo, a primeira cor disponível.
const DEFAULT_COLORS = { petals: "glossy-light-pink", center: "glossy-matcha-green", stems: "glossy-matcha-green", bow: "glossy-light-pink" };
const usableInput = (value) => {
  const input = getColorInput(value);
  return input && !input.disabled ? input : form.querySelector('input[name="color"]:not(:disabled)') || input;
};
const defaultParts = () => Object.fromEntries(parts.map((part) => [part, colorFromInput(usableInput(DEFAULT_COLORS[part]))]));

// Fonte única das cores (o renderer só aplica o que recebe). Vínculos em PRODUCT_CONFIG.linkedParts
// (laço ← pétalas, center ← hastes): a seguidora acompanha a líder até ter cor escolhida na própria aba.
const partLinks = PRODUCT_CONFIG.linkedParts || {};
const allLinked = () => Object.fromEntries(Object.keys(partLinks).map((part) => [part, true]));
const state = {
  size: "medium",
  activePart: "stems",
  linked: allLinked(),
  parts: defaultParts()
};

const money = (value) => `$${value.toFixed(2)}`;
const partLabels = { petals: "Petals", center: "Center", stems: "Stems", bow: "Bow" };

const capitalize = (text) => text[0].toUpperCase() + text.slice(1);
// Linha do fabricante (standard, retro, macaron, pearl, crystal) ou metallic.
const seriesOf = (value) => value.startsWith("metallic-") ? "metallic" : PRODUCT_CONFIG.colorSeries?.[value] || "standard";
const metallicParts = () => parts.filter((part) => seriesOf(state.parts[part].value) === "metallic");

// Uma linha por parte: base do resumo, das propriedades do carrinho e da tabela do PDF.
function partRows() {
  return parts.map((part) => {
    const color = state.parts[part];
    return { part: partLabels[part], label: color.label, hex: color.hex, image: swatchImage(color.value), finish: capitalize(seriesOf(color.value)), code: colorCode(color.value) || null };
  });
}

function partProperties() {
  const properties = {};
  for (const row of partRows()) {
    properties[row.part] = [row.label, row.finish, row.code && `Code: ${row.code}`].filter(Boolean).join(" · ");
  }
  return properties;
}

function configurationProperties() {
  return {
    Size: sizeInfo(state.size).label,
    ...partProperties(),
    "Gift card message": form.elements["gift-message"].value
  };
}

// Nome dos arquivos salvos (Save image e Save PDF): parte abreviada + cor + acabamento de cada
// peça, curto e legível (nomes completos e códigos ficam no PDF).
// Ex.: FlowersPop_Pet-LightPink-Std_Cen-MatchaGreen-Ret_Stm-MatchaGreen-Ret_Bow-Gold-Met
const partAbbreviations = { petals: "Pet", center: "Cen", stems: "Stm", bow: "Bow" };
const finishTags = { standard: "Std", retro: "Ret", macaron: "Mac", pearl: "Prl", crystal: "Cry", metallic: "Met" };
function exportFileName() {
  const partName = (part) => {
    const { value, label } = state.parts[part];
    const color = label.split(/[^A-Za-z0-9]+/).filter(Boolean).map((word) => word[0].toUpperCase() + word.slice(1)).join("");
    const series = seriesOf(value);
    return `${partAbbreviations[part]}-${color}-${finishTags[series] ?? series.slice(0, 3)}`;
  };
  return ["FlowersPop", ...parts.map(partName)].join("_");
}
// O renderer pergunta o nome ao baixar a imagem.
form.addEventListener("flowerspop:file-name", (event) => {
  event.detail.name = exportFileName();
});

const createConfigId = () => `fp_${new Date().toISOString().slice(0, 10).replaceAll("-", "")}_${Math.random().toString(36).slice(2, 8)}`;

// Linhas para /cart/add.js (§15–17): o buquê na variante do tamanho, com as cores como line item
// properties (campos com "_" ficam ocultos no checkout), e o Metallic Upgrade com quantidade =
// nº de partes metálicas, ligado ao buquê pelo mesmo _config_id. "_Design link" é o link do
// configurador com este buquê (tamanho, cores e vínculos; sem a mensagem do cartão): oculto para o
// cliente, aparece no pedido no admin e no app Shopify, e reabre o 3D (e o PDF) para a montagem.
function cartItems(configId = createConfigId()) {
  const properties = { ...partProperties() };
  const message = form.elements["gift-message"].value.trim();
  if (message) properties["Gift card message"] = message;
  for (const part of parts) {
    properties[`_${part}_hex`] = state.parts[part].hex;
    properties[`_${part}_finish`] = seriesOf(state.parts[part].value);
  }
  properties._config_id = configId;
  properties["_Design link"] = configUrl();

  const items = [{ id: sizeInfo(state.size).variantId, quantity: 1, properties }];
  const metallic = metallicParts();
  if (metallic.length) {
    items.push({
      id: metallicUpgrade.variantId,
      quantity: metallic.length,
      properties: { "Metallic parts": metallic.map((part) => partLabels[part]).join(", "), _config_id: configId }
    });
  }
  return items;
}

function renderPartSelection() {
  const active = state.parts[state.activePart];
  const activeInput = getColorInput(active.value);
  if (activeInput) activeInput.checked = true;
  const selected = form.querySelector("#selected-color");
  if (selected) {
    selected.querySelector(".selected-color-name").textContent = active.label;
    selected.querySelector(".selected-color-code").textContent = colorCode(active.value);
  }

  // Bolinha de cada parte (abas e chips do resumo): a esfera do swatch studio da cor escolhida,
  // sobre a cor lisa (que fica por baixo até a imagem carregar, ou se a cor não tiver imagem).
  const paintDot = (dot, color) => {
    const image = swatchImage(color.value);
    dot.style.setProperty("--dot", color.hex);
    dot.style.setProperty("--dot-image", image ? `url("${image}")` : "none");
    dot.classList.toggle("has-image", Boolean(image));
  };
  form.querySelectorAll(".part-tab .color-dot").forEach((dot) => {
    paintDot(dot, state.parts[dot.closest("label").htmlFor.replace("part-", "")]);
  });

  form.querySelectorAll(".mix-chip .color-dot").forEach((dot, index) => {
    paintDot(dot, state.parts[parts[index]]);
  });
}

// Preços do painel da página e do PDF: base do tamanho + US$ 3.50 por parte metálica.
function priceSummary() {
  const size = sizeInfo(state.size);
  const metallic = metallicParts().length;
  const upgrade = metallic * metallicUpgrade.price;
  return {
    base: money(size.price),
    upgrade: upgrade ? `+ ${money(upgrade)}` : "$0.00",
    total: money(size.price + upgrade),
    metallicParts: metallic,
    metallicUnit: money(metallicUpgrade.price),
  };
}

function renderPrice() {
  const size = sizeInfo(state.size);
  const prices = priceSummary();
  const cartButton = form.querySelector(".cart-button");

  for (const key of Object.keys(PRODUCT_CONFIG.sizes)) {
    const price = form.querySelector(`#size-${key}`)?.closest("label").querySelector(".size-price");
    if (price) price.textContent = `$${sizeInfo(key).price.toFixed(2).replace(/\.00$/, "")}`;
  }
  form.querySelector(".base-amount").textContent = prices.base;
  form.querySelector(".upgrade-amount").textContent = prices.upgrade;
  form.querySelector(".total-amount").textContent = prices.total;
  cartButton.querySelector("span").textContent = size.available ? `Add to cart · ${prices.total}` : "Sold out";
  cartButton.disabled = !size.available;
}

function render() {
  renderPartSelection();
  renderPrice();
  const summary = form.querySelector('.selection-details');
  const properties = configurationProperties();
  summary.replaceChildren(...parts.map((part) => {
    const item = document.createElement('li');
    item.textContent = `${partLabels[part]}: ${properties[partLabels[part]]}`;
    return item;
  }));
  form.dispatchEvent(new CustomEvent("flowerspop:parts", { detail: state.parts }));
}

form.addEventListener("change", (event) => {
  const input = event.target;

  if (input.name === "size") {
    state.size = input.value;
  }

  if (input.name === "part") {
    state.activePart = input.value;
  }

  if (input.name === "color") {
    const part = state.activePart;
    state.parts[part] = colorFromInput(input);
    if (part in state.linked) state.linked[part] = false;
    for (const [follower, leader] of Object.entries(partLinks)) {
      if (leader === part && state.linked[follower]) state.parts[follower] = { ...state.parts[part] };
    }
  }

  render();
});

// Dica com nome e código da cor ao passar o mouse (ou focar pelo teclado) num swatch. No toque não
// aparece: a cor tocada já fica marcada e o nome + código aparecem ao lado do título da paleta.
// Posição relativa ao painel, centrada no swatch e contida nas bordas do painel.
const palettePanel = form.querySelector(".palette-panel");
const swatchTip = palettePanel?.querySelector(".swatch-tip");
function showSwatchTip(label) {
  swatchTip.querySelector(".swatch-tip-name").textContent = label.dataset.name;
  swatchTip.querySelector(".swatch-tip-code").textContent = colorCode(label.querySelector("input").value);
  swatchTip.hidden = false;
  const panel = palettePanel.getBoundingClientRect();
  const swatch = label.getBoundingClientRect();
  const center = swatch.left + swatch.width / 2 - panel.left;
  const half = swatchTip.offsetWidth / 2;
  const left = Math.min(Math.max(center, half + 6), panel.width - half - 6);
  swatchTip.style.left = `${left}px`;
  swatchTip.style.top = `${swatch.top - panel.top}px`;
  swatchTip.style.setProperty("--arrow", `${center - left + half}px`);
}
const hideSwatchTip = () => { if (swatchTip) swatchTip.hidden = true; };
if (swatchTip) {
  palettePanel.addEventListener("pointerover", (event) => {
    const label = event.target.closest(".swatch");
    if (label && event.pointerType === "mouse") showSwatchTip(label);
  });
  palettePanel.addEventListener("pointerout", (event) => {
    const label = event.target.closest(".swatch");
    if (label && !label.contains(event.relatedTarget)) hideSwatchTip();
  });
  palettePanel.addEventListener("focusin", (event) => {
    const label = event.target.closest(".swatch");
    if (label && event.target.matches(":focus-visible")) showSwatchTip(label);
  });
  palettePanel.addEventListener("focusout", hideSwatchTip);
}

// Se o renderer 3D quebrar ao iniciar (ex.: navegador sem WebGPU), troca a tela de carregamento
// pela foto do produto em vez de deixá-la pulsando para sempre.
window.addEventListener("error", (event) => {
  if (!event.filename?.includes("/renderer.js")) return;
  document.querySelector(".preview-card")?.classList.add("is-failed");
  document.querySelector("#viewer-status").textContent = "The 3D preview is not available in this browser.";
});

// O renderer pede as cores atuais ao terminar de carregar o modelo.
form.addEventListener("flowerspop:get-parts", (event) => {
  event.detail.parts = state.parts;
});

form.addEventListener("reset", () => {
  requestAnimationFrame(() => {
    state.size = "medium";
    state.activePart = "stems";
    state.linked = allLinked();
    state.parts = defaultParts();
    render();
  });
});

// "Order details": mostra ou esconde a lista das cores escolhidas (o PDF tem botão próprio ao lado).
const detailsToggle = document.querySelector("#details-toggle");
detailsToggle?.addEventListener("click", () => {
  const open = detailsToggle.getAttribute("aria-expanded") !== "true";
  detailsToggle.setAttribute("aria-expanded", String(open));
  document.querySelector("#selection-details").hidden = !open;
});

// Na Shopify o botão adiciona ao carrinho; no protótipo local continua abrindo o aviso (popover).
if (shopify) {
  const cartButton = form.querySelector(".cart-button");
  const status = document.querySelector("#export-status");
  cartButton.removeAttribute("popovertarget");
  cartButton.addEventListener("click", async () => {
    cartButton.disabled = true;
    status.textContent = "Adding your bouquet to the cart…";
    try {
      const response = await fetch(`${shopify.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: cartItems() })
      });
      if (!response.ok) throw new Error((await response.json().catch(() => ({}))).description || response.statusText);
      window.location.href = `${shopify.root}cart`;
    } catch (error) {
      status.textContent = `Could not add to cart: ${error.message}`;
      renderPrice();
    }
  });
}

// Contador da mensagem do cartão (0/120), atualizado ao digitar e ao resetar o formulário.
const giftMessage = form.elements["gift-message"];
const giftCount = document.querySelector("#gift-count");
const renderGiftCount = () => {
  if (giftCount) giftCount.textContent = `${giftMessage.value.length}/${giftMessage.maxLength}`;
};
giftMessage.addEventListener("input", renderGiftCount);
form.addEventListener("reset", () => requestAnimationFrame(renderGiftCount));
renderGiftCount();

// Change style: um cartão por arranjo de PRODUCT_CONFIG.styles. O atual só fecha o seletor; um
// arranjo com `url` leva à página dele; sem `url`, fica desativado como "Coming soon".
const stylePicker = document.querySelector("#style-picker");
const assetUrl = (path) => window.FLOWERSPOP_ASSETS?.[path] || path;
function renderStyles() {
  const list = stylePicker?.querySelector(".style-options");
  if (!list) return;
  list.replaceChildren(...(PRODUCT_CONFIG.styles || []).map((style) => {
    const item = document.createElement("li");
    const button = document.createElement("button");
    button.type = "button";
    button.className = "style-option";
    button.dataset.style = style.id;
    const image = new Image();
    image.src = assetUrl(style.image);
    image.alt = "";
    const name = document.createElement("span");
    name.className = "style-option-name";
    name.textContent = style.name;
    const status = document.createElement("span");
    status.className = "style-option-status";
    status.textContent = style.current ? "Current style" : style.url ? "Customize this style" : "Coming soon";
    if (style.current) button.setAttribute("aria-current", "true");
    button.disabled = !style.current && !style.url;
    button.addEventListener("click", () => {
      if (style.current) stylePicker.hidePopover();
      else window.location.href = style.url;
    });
    button.append(image, name, status);
    item.append(button);
    return item;
  }));
}
renderStyles();

// Exposto para testes e para o tema (ex.: um carrinho em gaveta que prefira fazer o próprio POST).
window.FlowersPopConfigurator = { cartItems, configurationProperties };

// Aviso de exportação (Save image / Save PDF): logo pulsando + barra de progresso até o arquivo
// ficar pronto, para o cliente ver na hora que o clique funcionou (a captura em 4K leva alguns
// segundos antes de o navegador perguntar onde salvar). Diálogo modal: bloqueia cliques repetidos.
// A barra: captura (quadros do renderer) até 70–85%, depois compressão da imagem ou montagem do PDF.
const exportDialog = document.querySelector('#export-progress');
const exportBar = exportDialog?.querySelector('[role="progressbar"]');
const EXPORT_STEPS = { image: { capture: [0.04, 0.85], encoding: 0.93 }, pdf: { capture: [0.04, 0.7], building: 0.88 } };
let exportKind = null;
function setExportProgress(value) {
  exportDialog?.style.setProperty('--progress', value.toFixed(3));
  exportBar?.setAttribute('aria-valuenow', String(Math.round(value * 100)));
}
function startExport(kind, title) {
  if (!exportDialog) return;
  exportKind = kind;
  exportDialog.classList.remove('is-done');
  exportDialog.querySelector('h2').textContent = title;
  exportDialog.querySelector('p').textContent = 'This takes a few seconds. Your download starts automatically.';
  setExportProgress(EXPORT_STEPS[kind].capture[0]);
  if (!exportDialog.open) exportDialog.showModal();
}
function stepExport(step) {
  if (exportKind) setExportProgress(EXPORT_STEPS[exportKind][step]);
}
function finishExport(ok) {
  if (!exportDialog?.open) return;
  exportKind = null;
  if (!ok) {
    exportDialog.close();
    return;
  }
  setExportProgress(1);
  exportDialog.classList.add('is-done');
  exportDialog.querySelector('h2').textContent = 'Your download is ready';
  exportDialog.querySelector('p').textContent = 'Choose where to save it, if your browser asks.';
  setTimeout(() => exportDialog.open && exportDialog.close(), 1100);
}
exportDialog?.addEventListener('cancel', (event) => event.preventDefault()); // Esc não fecha no meio
form.addEventListener('flowerspop:export-progress', (event) => {
  if (!exportKind) return;
  const [from, to] = EXPORT_STEPS[exportKind].capture;
  setExportProgress(from + (to - from) * event.detail.capture);
});
// Save image (renderer.js) avisa início, compressão, fim e erro.
form.addEventListener('flowerspop:export', ({ detail }) => {
  if (detail.state === 'start') startExport(detail.kind, detail.title);
  else if (detail.state === 'encoding') stepExport('encoding');
  else finishExport(detail.state === 'end');
});

// Captura do renderer: Promise do PNG em resolução de impressão (undefined antes do 3D carregar).
const captureImage = () => {
  const capture = {};
  form.dispatchEvent(new CustomEvent('flowerspop:capture', { detail: capture }));
  return capture.image;
};

// PDF do pedido (src/pdf.js), no tema da página: cabeçalho com a marca, foto grande, preços, QR do
// AR + link da configuração, uma ficha por parte e a mensagem do cartão. É o arquivo do botão
// "Save PDF" e o que o futuro adaptador do carrinho pede com flowerspop:pdf (event.detail.pdf).
async function configurationPdf(onStep = () => {}) {
  const image = captureImage();
  if (!image) throw new Error('3D preview not ready');
  const link = configUrl();
  const spec = currentARSpec(true); // o QR abre sem mesa: na altura de uma mesa
  const arUrl = spec && AR.service ? `${arEndpoint('go', spec)}?back=${encodeURIComponent(link)}` : link;
  if (spec) prepareAR(spec).catch(() => {}); // gera os arquivos de AR: o QR abre na hora
  // carrega o jsPDF e o gerador de QR só quando precisa, em paralelo com a captura
  const [src, { createConfigurationPdf }, qrcode] = await Promise.all([image, import('./flowerspop-pdf.js?v=07617c6ba8'), loadQrLibrary()]);
  onStep('building');
  const qr = qrcode(0, 'L'); // o link é longo (configuração inteira): "L" = módulos maiores, leitura mais fácil
  qr.addData(arUrl);
  qr.make();
  const cells = qr.getModuleCount();
  const modules = Array.from({ length: cells }, (_, r) => Array.from({ length: cells }, (_, c) => qr.isDark(r, c)));
  return createConfigurationPdf({
    image: src,
    logo: assetUrl('/assets/brand/flowerspop-mark.png'), // no tema, a URL do CDN da Shopify
    product: 'FlowersPop DIY Box',
    style: 'Blush Tulip',
    size: sizeInfo(state.size).label,
    date: new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
    message: form.elements['gift-message'].value,
    rows: partRows(),
    prices: priceSummary(),
    ar: { modules, link },
  });
}
form.addEventListener('flowerspop:pdf', (event) => {
  event.detail.pdf = configurationPdf();
});

// Save PDF: baixa o arquivo pronto (sem a janela de impressão do navegador, que mudava de
// orientação e somava data/URL nas margens), com o nome das cores e acabamentos de cada peça.
document.querySelector('#save-pdf').addEventListener('click', async (event) => {
  const button = event.currentTarget;
  const status = document.querySelector('#export-status');
  if (!captureImage()) {
    status.textContent = 'Wait for the 3D preview to load before saving.';
    return;
  }
  button.disabled = true;
  status.textContent = 'Preparing your PDF for download…';
  startExport('pdf', 'Preparing your PDF for download…');
  try {
    const pdf = await configurationPdf(stepExport);
    const link = document.createElement('a');
    link.download = `${exportFileName()}.pdf`;
    link.href = URL.createObjectURL(pdf);
    link.click();
    setTimeout(() => URL.revokeObjectURL(link.href), 60_000);
    status.textContent = '';
    finishExport(true);
  } catch {
    finishExport(false);
    status.textContent = 'Could not prepare the PDF. Please try again.';
  } finally {
    button.disabled = false;
  }
});

// Configuração no link (?fp=…): o QR code do AR leva tamanho, cores e vínculos para o celular.
const toBase64Url = (text) => btoa(text).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, "");
const fromBase64Url = (text) => atob(text.replaceAll("-", "+").replaceAll("_", "/"));
function configUrl() {
  // Link limpo: só a página do produto + a configuração, sem os parâmetros da visita atual
  // (utm_*, fbclid, variant...), que iriam parar no pedido, no QR code e no PDF.
  const url = new URL(window.location.pathname, window.location.origin);
  const data = { s: state.size, p: Object.fromEntries(parts.map((part) => [part, state.parts[part].value])), l: state.linked };
  url.searchParams.set("fp", toBase64Url(JSON.stringify(data)));
  // Em tema de prévia (não publicado), a Shopify tira o preview_theme_id da barra de endereço;
  // sem ele o celular abriria o tema publicado, que não tem o configurador.
  const theme = window.Shopify?.theme;
  if (theme?.id && theme.role && theme.role !== "main") url.searchParams.set("preview_theme_id", theme.id);
  url.hash = "";
  return url.href;
}
function applyConfigFromUrl() {
  const raw = new URL(window.location.href).searchParams.get("fp");
  if (!raw) return;
  try {
    const data = JSON.parse(fromBase64Url(raw));
    if (PRODUCT_CONFIG.sizes[data.s]) {
      state.size = data.s;
      form.querySelector(`#size-${data.s}`).checked = true;
    }
    for (const part of parts) {
      const value = data.p?.[part];
      const input = typeof value === "string" && getColorInput(CSS.escape(value));
      if (input && !input.disabled) state.parts[part] = colorFromInput(input); // indisponível: fica o padrão
    }
    for (const part of Object.keys(state.linked)) {
      if (typeof data.l?.[part] === "boolean") state.linked[part] = data.l[part];
    }
  } catch {
    // Link inválido: fica a configuração padrão.
  }
}

// View in your space: os arquivos de AR de cada configuração são gerados na AWS (aws/ar-service)
// e ficam em HTTPS público — os apps de AR do celular não abrem arquivos gerados no navegador.
// iPhone: pergunta se há mesa por perto e abre o AR Quick Look — na mesa (apoiado) ou sem mesa
// (flutua em PRODUCT_CONFIG.ar.tableHeight acima do piso); o Quick Look não informa a altura da
// superfície, então a escolha é do cliente. Android: vai para a página /go do serviço, cujo AR
// próprio (WebXR) decide a altura sozinho (mesa apoia; senão, na altura dos olhos).
// Computador: QR code da mesma página /go (o PDF usa o mesmo QR).
const AR = PRODUCT_CONFIG.ar || {};
const arButton = document.querySelector("#view-in-ar");
const arQr = document.querySelector("#ar-qr");
const arPlace = document.querySelector("#ar-place");
for (const label of document.querySelectorAll(".ar-table-height")) label.textContent = `${Math.round((AR.tableHeight ?? 0.85) * 100)} cm`;
const isAndroid = /Android/i.test(navigator.userAgent);
// iPad no modo desktop se apresenta como Mac com toque; o Android vem antes, para não cair nessa regra.
const isIOS = !isAndroid && (/iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1));
const isMobile = isIOS || isAndroid;
// Navegadores do iPhone que abrem o Quick Look por link HTTPS mesmo sem anunciar rel="ar".
const isIOSBrowserApp = /CriOS\/|EdgiOS\/|FxiOS\/|GSA\/|DuckDuckGo\//.test(navigator.userAgent);
const arPrepared = new Map(); // spec -> { glb, usdz } já preparados no servidor
let arTimer;

const showARStatus = (message) => {
  const status = document.querySelector("#export-status");
  if (status) status.textContent = message;
};
// elevated = "sem mesa": o buquê flutua na altura de uma mesa (h50e85_…).
function currentARSpec(elevated = false) {
  const detail = { size: state.size, elevation: elevated ? AR.tableHeight ?? 0.85 : 0 };
  form.dispatchEvent(new CustomEvent("flowerspop:ar-spec", { detail }));
  return detail.spec || null;
}
const arEndpoint = (route, spec) => `${AR.service}/${route}/v1/${AR.product}/${spec}`;
// Pede ao servidor os dois arquivos da configuração atual (gera se ainda não existem).
async function prepareAR(spec = currentARSpec()) {
  if (!spec || !AR.service) return null;
  if (arPrepared.has(spec)) return { spec, urls: arPrepared.get(spec) };
  const response = await fetch(arEndpoint("ar", spec));
  if (!response.ok) throw new Error(`AR service ${response.status}`);
  arPrepared.set(spec, await response.json());
  return { spec, urls: arPrepared.get(spec) };
}
// No celular, prepara as duas versões (na mesa e sem mesa) em segundo plano após cada mudança:
// a escolha abre a câmera na hora.
const scheduleAR = () => {
  clearTimeout(arTimer);
  arTimer = setTimeout(() => {
    for (const elevated of [false, true]) prepareAR(currentARSpec(elevated)).catch(() => {});
  }, 800);
};
if (isMobile) {
  form.addEventListener("flowerspop:ar-ready", scheduleAR);
  form.addEventListener("flowerspop:parts", scheduleAR);
}

function openQuickLook(usdzUrl) {
  const anchor = document.createElement("a");
  if (!anchor.relList.supports?.("ar") && !isIOSBrowserApp) {
    // Navegador interno de apps (Instagram, Facebook…): o iOS não abre o AR ali.
    showARStatus("To view in your space, open this page in Safari (tap ••• and choose Open in browser).");
    return;
  }
  anchor.rel = "ar";
  anchor.href = `${usdzUrl}#allowsContentScaling=0`; // tamanho real, sem pinça para escalar
  anchor.append(document.createElement("img")); // o Quick Look exige um <img> dentro do link
  anchor.style.display = "none";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
}

// Gerador de QR (qrcode-generator), carregado só quando precisa: popover do AR e PDF.
async function loadQrLibrary() {
  if (!window.qrcode) {
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.js";
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    });
  }
  return window.qrcode;
}

async function showARQrCode() {
  const spec = currentARSpec(true); // o QR abre sem mesa: na altura de uma mesa
  if (!spec) {
    showARStatus("Wait for the 3D preview to load, then try again.");
    return;
  }
  const back = configUrl();
  showARStatus("Preparing your QR code…");
  await prepareAR(spec); // gera antes: no celular a câmera abre sem espera
  const url = `${arEndpoint("go", spec)}?back=${encodeURIComponent(back)}`;
  const link = arQr.querySelector("#ar-qr-url");
  link.href = back;
  const qrcode = await loadQrLibrary();
  const qr = qrcode(0, "L"); // na tela não há dano: "L" dá um QR menos denso, lido mais fácil
  qr.addData(url);
  qr.make();
  arQr.querySelector(".ar-qr-code").innerHTML = qr.createSvgTag({ cellSize: 4, margin: 2, scalable: true });
  arQr.dataset.url = url; // exposto para testes
  showARStatus("");
  arQr.showPopover();
}

// iPhone: a opção escolhida abre o Quick Look. Já preparado: link direto do S3; senão, a rota do
// serviço gera e redireciona (sem perder o toque).
function openAR(elevated) {
  const spec = currentARSpec(elevated);
  if (!spec) {
    showARStatus("Wait for the 3D preview to load, then tap again.");
    return;
  }
  showARStatus("");
  openQuickLook(arPrepared.get(spec)?.usdz ?? `${arEndpoint("ar", spec)}.usdz`);
}

arButton?.addEventListener("click", () => {
  if (!isMobile) {
    showARQrCode().catch(() => showARStatus("Could not create the QR code. Open this page on your phone to view in your space."));
    return;
  }
  const spec = currentARSpec(true);
  if (!spec) {
    showARStatus("Wait for the 3D preview to load, then tap again.");
    return;
  }
  if (isAndroid) {
    // AR próprio com altura automática (página /go do serviço), volta para esta configuração.
    window.location.href = `${arEndpoint("go", spec)}?back=${encodeURIComponent(configUrl())}`;
    return;
  }
  arPlace.showPopover(); // iPhone: tem mesa por perto? o toque na opção abre a câmera
});
for (const option of arPlace?.querySelectorAll("[data-placement]") ?? []) {
  option.addEventListener("click", () => {
    arPlace.hidePopover();
    openAR(option.dataset.placement === "floor");
  });
}

// Exposto para testes: link da configuração atual.
window.FlowersPopConfigurator.configUrl = configUrl;
window.FlowersPopConfigurator.applyColorCatalog = applyColorCatalog;

applyConfigFromUrl();

render();
